/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Faq_Stack_AnswerInputs */

const en_landing_faq_stack_answer = /** @type {(inputs: Landing_Faq_Stack_AnswerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Next.js 16 with the App Router, React 19, TypeScript strict mode, Tailwind CSS 4, shadcn/ui, Drizzle ORM, and better-auth. Every piece of business logic is inlined — no external packages for payment, email, storage, or AI.`)
};

const zh_landing_faq_stack_answer = /** @type {(inputs: Landing_Faq_Stack_AnswerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Next.js 16（App Router）、React 19、TypeScript 严格模式、Tailwind CSS 4、shadcn/ui、Drizzle ORM 和 better-auth。所有业务逻辑都内置在代码里——支付、邮件、存储、AI 都不依赖外部包。`)
};

/**
* | output |
* | --- |
* | "Next.js 16 with the App Router, React 19, TypeScript strict mode, Tailwind CSS 4, shadcn/ui, Drizzle ORM, and better-auth. Every piece of business logic is i..." |
*
* @param {Landing_Faq_Stack_AnswerInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const landing_faq_stack_answer = /** @type {((inputs?: Landing_Faq_Stack_AnswerInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Faq_Stack_AnswerInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_landing_faq_stack_answer(inputs)
	return zh_landing_faq_stack_answer(inputs)
});
export { landing_faq_stack_answer as "landing.faq.stack.answer" }